import { DictionariesEditPage } from 'features/dictionaries/components/DictionariesEditPage'
import { DictionaryType } from 'features/dictionaries/types'

export const DictionariesEquipmentEditPage = () => {
  return <DictionariesEditPage type={DictionaryType.Equipment} />
}
